import React, { useCallback, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { Api } from 'lavva.exalushome';
import 'regenerator-runtime';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { App, AppLocal } from './App';
import { ServiceWorkerUpdateDialog } from './components/service-worker-update-dialog';
import { SplashScreen } from './components/splashscreen';
import { BackdropContextProvider } from './context/backdrop';
import { environment } from './environment';
// import { useSWPrompt } from './hooks/service-worker-update/use-sw-prompt';
import { checkCacheVersion } from './integrations/lavva/utils/cache';
import { initSentry } from './sentry';
import { Tokens } from './types/auth';
import queryClient from './utils/clients/query-client';
import { isLocalhost, isProd } from './utils/helpers/environment';
import { isLocalApp } from './utils/helpers/local-app';
import { getKeycloakInitOptions, keycloakInstance, setTokens } from './utils/keycloak';
import { setTheme } from './utils/theme';
import './utils/translations/i18n';

if (isProd || isLocalhost) window.loglevel = 4;
Api.Init();
const keycloakInitOptions = getKeycloakInitOptions();

const Providers: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    {!isLocalApp ? <App /> : <AppLocal />}
    {!isProd && <code className="app-version">v.{environment.VERSION}</code>}
  </QueryClientProvider>
);

const Root: React.FC = () => {
  const [tokenUpdateCount, setTokenUpdateCount] = useState<number>(0);
  // const { showDialog, setShowDialog, handleUpdate } = useSWPrompt();

  useEffect(() => {
    setTheme();
    checkCacheVersion();
  }, []);

  const onTokens = useCallback(
    ({ token, idToken, refreshToken }: Tokens) => {
      if (token && idToken && refreshToken) {
        setTokens({ token, idToken, refreshToken });
        setTokenUpdateCount((value) => value + 1);
      }
    },
    [tokenUpdateCount],
  );

  return (
    <BackdropContextProvider>
      {!isLocalApp ? (
        <ReactKeycloakProvider
          authClient={keycloakInstance}
          initOptions={keycloakInitOptions}
          LoadingComponent={<SplashScreen />}
          onTokens={onTokens}
        >
          <Providers />
        </ReactKeycloakProvider>
      ) : (
        <Providers />
      )}
      {/* <ServiceWorkerUpdateDialog show={showDialog} setShow={setShowDialog} onUpdate={handleUpdate} /> */}
    </BackdropContextProvider>
  );
};

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<Root />);
initSentry();
